<a [href]="href" [target]="isExternal ? '_blank' : '_self'">
	{{ text ?? fallback }}
</a>
